import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { cmApi } from "./cmApi";

// ComplianceMinder MVP home — at-a-glance counts + entry points.
export default function ComplianceDashboard() {
  const [counts, setCounts] = useState({ policies: 0, registers: 0, bundles: 0 });
  const [tenant, setTenant] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [health, policies, registers, bundles] = await Promise.all([
          cmApi.health(),
          cmApi.listPolicies(),
          cmApi.listRegisters(),
          cmApi.listBundles(),
        ]);
        setTenant(health.tenant || "");
        setCounts({
          policies: policies.length,
          registers: registers.length,
          bundles: bundles.length,
        });
      } catch (e) {
        setError("Could not load compliance data. Is the module enabled?");
      }
    })();
  }, []);

  const tiles = [
    { label: "Policies", value: counts.policies, to: "/compliance/mvp/policies" },
    { label: "Registers", value: counts.registers, to: "/compliance/mvp/registers" },
    { label: "Bundles", value: counts.bundles, to: "/compliance/mvp/bundles" },
  ];

  return (
    <div className="p-6" data-testid="cm-dashboard">
      <h1 className="text-xl font-semibold text-slate-800">ComplianceMinder</h1>
      {tenant && <p className="mt-1 text-sm text-slate-500">Tenant: {tenant}</p>}
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {tiles.map((t) => (
          <Link
            key={t.label}
            to={t.to}
            className="rounded-lg border border-slate-200 p-5 hover:border-indigo-400 hover:shadow-sm transition"
            data-testid={`cm-tile-${t.label.toLowerCase()}`}
          >
            <div className="text-3xl font-semibold text-slate-800">{t.value}</div>
            <div className="mt-1 text-sm text-slate-500">{t.label}</div>
          </Link>
        ))}
      </div>

      <Link
        to="/compliance/mvp/competence"
        className="mt-6 inline-block text-sm text-indigo-700 hover:underline"
        data-testid="cm-link-competence"
      >
        My competence log
      </Link>
    </div>
  );
}
